import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  function logOut() {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsed = JSON.parse(userData);
      if (!!parsed?.isAuthenticated) {
        if (parsed?.userDetails?.storeId ?? null) {
          navigate('/layout');
        } else {
          navigate('/layout/no-store');
        }
      }
    }
  }

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: "top", overflow: "hidden" }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 3,
          width: '100%',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 100, color: 'error.main' }} />
        <Typography variant="h1" component="h1" sx={{ fontSize: '4rem', fontWeight: 'bold' }}>
          404
        </Typography>
        <Typography variant="h4" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => logOut()}
        >
          Back to Home Page
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorPage;
